import {
    ConstructionProjectSearchResponse,
    FilterOptionsConstructionProject,
    GetConstructionProjectListResponseSchema,
    GetConstructionProjectResponse,
    GetConstructionProjectResponseSchema,
    GetConstructionProjectsListResponse,
} from './types/constructionProject';
import { useHttpClientContext } from '@/shared/context/HttpClientContext.tsx';
import { ProjectNumber } from '@schuettflix/interfaces';

export function useGetConstructionProjectListByOrganizationIdAndStatusIn() {
    const { constructionProjectClient } = useHttpClientContext();
    return {
        getConstructionProjectListByOrganizationIdAndStatusIn: async (
            organizationId: number,
            filterOptions: FilterOptionsConstructionProject
        ) => {
            return constructionProjectClient
                .get<GetConstructionProjectsListResponse>(
                    `/admin/v1/organizations/${organizationId}/construction-projects`,
                    {
                        params: filterOptions,
                    }
                )
                .then(res => GetConstructionProjectListResponseSchema.parse(res.data));
        },
    };
}

export function useGetConstructionProjectById() {
    const { constructionProjectClient } = useHttpClientContext();
    return {
        getConstructionProjectById: (id: string) =>
            constructionProjectClient
                .get<GetConstructionProjectResponse>(`/admin/v1/construction-projects/${id}`)
                .then(res => GetConstructionProjectResponseSchema.parse(res.data)),
    };
}

export function useGetConstructionProjectByNumberClient() {
    const { constructionProjectClient } = useHttpClientContext();
    return {
        getConstructionProjectProjectNumber: (projectNumber: ProjectNumber) =>
            constructionProjectClient
                .get<GetConstructionProjectResponse>(`/admin/v1/construction-projects/${projectNumber}`)
                .then(res => GetConstructionProjectResponseSchema.parse(res.data)),
    };
}

export function useSearchConstructionProjects() {
    const { constructionProjectClient } = useHttpClientContext();
    return {
        searchConstructionProjects: (searchTerm: string, page = 1, size = 25) =>
            constructionProjectClient
                .get<ConstructionProjectSearchResponse>('/admin/v1/construction-projects', {
                    params: { searchTerm, page, size, status: 'ACTIVE' },
                })
                .then(res => res.data),
    };
}
